// tslint:disable:max-line-length
import {Injectable} from '@angular/core';
import {BootstrapData} from '@core/interfaces/bootstrap.interface';

@Injectable({
  providedIn: 'root'
})
export class BootstrapLicenseDataService {
  private _bootstrapData: BootstrapData = {} as BootstrapData;
  private _isBootstrapError: boolean = false;
  private _standardsTypesLeftInfo: string = 'Nie wybrano wszystkich norm, które przysługują w ramach pakietu.<br>Przejdź do:<br><strong>"Ustawienia -> Licencja -> Normy w pakiecie"</strong><br>i uzupełnij normy.';

  setBootstrapData(data: BootstrapData): void {
    this._bootstrapData = data;
  }

  getBootstrapData(): BootstrapData {
    return this._bootstrapData;
  }

  setBootstrapError(isError: boolean): void {
    this._isBootstrapError = isError;
  }

  getBootstrapError(): boolean {
    return this._isBootstrapError;
  }

  resetBootstrapLicenseData(): Promise<null> {
    return new Promise<null>(resolve => {
      this.setBootstrapError(false);
      this.setBootstrapData({} as BootstrapData);

      resolve(null);
    });
  }

  /** Zwraca informację, czy firma ma do ustawienia normy, które przysługują jej w pakiecie */
  get isStandardsTypesLeft(): boolean {
    const leftStandardsTypes = this.getBootstrapData().standard_types_left;

    return leftStandardsTypes && leftStandardsTypes > 0;
  }

  /** Zwraca komunikat, informujący o tym, że firma nie wybrała wszystkich norm, które przysługują jej w pakiecie */
  get getStandardsTypesLeftInfo(): string {
    return this.isStandardsTypesLeft ? this._standardsTypesLeftInfo : null;
  }
}
